import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { LeadFormJobQuery, LeadFormJobQueryVariables } from './__generated__/LeadFormJobQuery';

const LEAD_FORM_JOB_QUERY = gql`
  query LeadFormJobQuery($id: ID!) {
    jobsFacebookLeadgenFormsMutateJob(id: $id) {
      id
      status
      jobErrors
      items {
        id
        leadgenFormId
        leadgenFormName
        article {
          id
        }
        itemErrors
        partialResult {
          createLeadgenForm {
            leadgenFormId
            status
            error
            duplicateCreatives {
              creativeId
              duplicatedFromCreativeId
              status
              error
              uploadFacebookAds {
                audienceId
                facebookAdId
                status
                error
              }
              customerApproval {
                error
                status
              }
            }
          }
          deprecateLeadgenForm {
            error
            discardLeadgenForm {
              leadgenFormId
              error
              status
            }
            pauseCreatives {
              creativeId
              status
              error
              pauseFacebookAds {
                facebookAdId
                status
                error
                facebookAd {
                  facebookState
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const useLeadFormJobLazyQuery = () => {
  return useLazyQuery<LeadFormJobQuery, LeadFormJobQueryVariables>(LEAD_FORM_JOB_QUERY, {
    client: kmsClient,
    fetchPolicy: 'cache-first'
  });
};
